import { registerPlugin as capacitorRegisterPlugin } from "@capacitor/core"
import type { BasePlugin } from "./types"
import { registerIngenicoPlugin } from "./registerIngenicoPlugin"

/**
 * Uses the current platform and `pluginName` to return an appropriate plugin implementation.
 * @param pluginName Used to find the android plugin class in the case platform is not web (in this case it has no effect).
 *
 * If platform is "ingenicoNerpay" this must match the string passed to `registerPlugin` in `MainActivity`.
 *
 * If the platform is "paxPositive" or "paxEvo" this must match the `name` attribute of the `CapacitorPlugin` annotation on the plugin class.
 *
 * @param webImplementation The implementation to run when app is running on web platform.
 * @returns Platform-appropriate plugin implementation
 */
export const registerPlugin = <T extends BasePlugin>(
  pluginName: string,
  webImplementation: T
): T =>
  import.meta.env.VITE_PLATFORM === "web"
    ? webImplementation
    : import.meta.env.VITE_PLATFORM === "ingenicoNerpay"
      ? registerIngenicoPlugin(pluginName)
      : capacitorRegisterPlugin(pluginName)
